import React, { useEffect } from 'react';
import useUser from '../../hooks/useUser'
import { Create, SimpleForm, TextInput, ReferenceInput, SelectInput, BooleanInput } from 'react-admin';
import { parse } from "query-string";
import validateContact from '../../validators/ContactValidate'
import OrgSelector from '../../components/OrgSelector';
import CreateToolBar from '../../components/CreateToolBar'
import ContactOptInCheckBox from '../../components/ContactOptInCheckbox'
import { getContactList } from '../../utils/contactList';

const ContactCreate = (props) => {
    const user = useUser()
    const showOrgSelector = user.role === 'super-admin' || (user.Organizations && user.Organizations.length > 1)
    let { organization_id, contactlist_id, redirect_origin } = parse(props.location.search);

    let redirect

    if (redirect_origin === 'Contactlists' && organization_id) redirect = `/Contactlists/${contactlist_id}/show?organization_id=${organization_id}`
    else if (redirect_origin === 'Contactlists') redirect = `/Contactlists/${contactlist_id}/show`
    else if (redirect_origin === 'Contactlists_edit') redirect = `/Contactlists/${contactlist_id}/edit`
    else if (redirect_origin === "Organizations") redirect = `/${redirect_origin}/${organization_id}/show`

    useEffect(() => {
        const retrieveCL = async () => {
            if (contactlist_id) {
                const contactlist = await getContactList(contactlist_id)
                if (contactlist) organization_id = contactlist.org_id
            }
        }
        retrieveCL()
    }, [contactlist_id])


    if (organization_id) organization_id = parseInt(organization_id)
    if (contactlist_id) contactlist_id = parseInt(contactlist_id)

    return (<Create {...props}>
        <SimpleForm redirect={redirect}  toolbar={<CreateToolBar history={props.history} />}>

            <OrgSelector fullWidth source="org_id" org_id={organization_id} locked={organization_id} required/>

            {contactlist_id ?
                <ReferenceInput style={{display: 'none'}} perPage={1000000000000} disabled fullWidth label="Choose Contact List" source="contactlist_id" reference="contactlists" >
                    <SelectInput optionText="name" initialValue={contactlist_id} />
                </ReferenceInput>
                : null}

            {!showOrgSelector && user.Organizations && <TextInput source='org_id' initialValue={user.Organizations[0].id} style={{ display: 'none' }} />}

            <TextInput fullWidth label={"First Name"} source="firstName" required />
            <TextInput fullWidth label="Last Name" source="lastName" required />
            <TextInput fullWidth label="Email" source="email" required />
            <TextInput fullWidth label="Phone Number" source="phone" required />
            <BooleanInput required label="" source="optIn" />
            <ContactOptInCheckBox />
        </SimpleForm>
    </Create>)
}

export default ContactCreate